module.exports = __webpack_public_path__ + "img/g2.1962c43b.png";